const MSG_VISIO ={
    FERMER_VISIO : -1,
    OUVRIR_VISIO : 1,
    SET_TEACHER_CONNECTED : 2,
    ALL_IN_VISIO:3,
    OUVRIR_CAMERA:4,
    FERMER_CAMERA:5,
    OUVRIR_MICROPHONE : 6,
    FERMER_MICROPHONE : 7,
    AGRANDIR_VIDEO : 8,
    REDUIRE_VIDEO : 9,
    APPEL_TEACHER:10,
    OUVRIR_CONFERENCE:11,
    GROUPE_IN_VISIO:12,
    GROUPE_OUT_VISIO:13,
    FERMER_CONFERENCE:14,
    GROUPE_IN_RECORD:15,
    GROUPE_OUT_RECORD:16,
    GROUPE_IN_MATIERE:17,
    GROUPE_OUT_MATIERE:18,
    ALL_OUT_VISIO:19,
    OUVRIR_PROF_CONFERENCE:20,
    CLASSES_HASCHANGED:21
  }

  export {MSG_VISIO}